function getOpenLayersCSS() {
  return {
    '.ol-zoom': {
      right: '.5em',
      bottom: '1.5em',
      top: 'unset',
      left: 'unset',
    },
  }
}

export default getOpenLayersCSS
